"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Sparkles, Music, WandSparkles } from "lucide-react";
export default function TheMagicBehindTheLens() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223298" id="quality-in-every-detail" className="bg-background text-foreground py-20 lg:py-32 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto bg-card rounded-lg overflow-hidden border border-border/40 shadow-xl flex flex-col lg:flex-row relative z-10">
        
        {}
        <div className="w-full lg:w-1/2 relative min-h-[450px] lg:min-h-[650px] group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_membrane_texture_macro.png" alt="High-performance roofing membrane detail" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-card/20 lg:to-card" />
          <div className="absolute inset-0 bg-primary/10 mix-blend-overlay" />
          
          {}
          <div className="absolute bottom-8 left-8 flex items-center gap-2 bg-background/90 backdrop-blur-sm border border-border/50 px-4 py-2 rounded-full shadow-md">
            <WandSparkles className="w-4 h-4 text-ring animate-pulse" />
            <span className="text-xs font-mono text-foreground/80 tracking-widest uppercase">Analyzing Spec...</span>
          </div>
        </div>

        {}
        <div className="hidden lg:block absolute left-1/2 top-12 bottom-12 w-[1px] bg-gradient-to-b from-transparent via-primary/20 to-transparent z-20 -translate-x-1/2" />

        {}
        <div ref={ref} className={`w-full lg:w-1/2 p-8 md:p-12 lg:p-20 xl:p-24 flex flex-col justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="flex items-center gap-3 mb-6">
            <Sparkles className="w-5 h-5 text-ring" />
            <span className="text-primary font-mono tracking-widest uppercase text-xs md:text-sm">
              Technical Specification
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold font-default mb-8 leading-[1.1] tracking-tighter">
            Built to <br />
            <span className="text-muted-foreground font-light">Outlast the</span>{" "}
            <span className="text-primary italic font-default">Elements.</span>
          </h2>

          <p className="text-muted-foreground text-lg md:text-xl mb-8 leading-relaxed font-default">
            At RM Roofing & Waterproofing, we engineer protection. Our multi-layered membrane technology creates an impenetrable shield, ensuring structural integrity and thermal efficiency for residential and industrial properties alike.
          </p>

          <div className="flex items-start gap-5 mb-10 p-6 bg-muted/50 rounded-lg border border-border/30">
            <div className="mt-1 bg-accent p-3 rounded-full shrink-0">
              <Music className="w-6 h-6 text-ring" />
            </div>
            <div>
              <h3 className="text-foreground font-bold text-xl mb-2 font-default">
                Advanced Insulation Layers
              </h3>
              <p className="text-muted-foreground leading-relaxed font-default">
                Thermal performance is integrated into every seal. Our high-density insulation cores reduce energy loss while providing superior moisture resistance and acoustic dampening.
              </p>
            </div>
          </div>

          <div>
          
          </div>
        </div>
      </div>
    </section>;
}